import MapComp from './map';

const port = {
  MapComp,
};

export default port;
